"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./SFErrorDialogContent.css");
var ErrorRounded_1 = __importDefault(require("@material-ui/icons/ErrorRounded"));
var Info_1 = __importDefault(require("@material-ui/icons/Info"));
var SFErrorDialogContent = function (_a) {
    var title = _a.title, message = _a.message, messageJson = _a.messageJson;
    var _b = react_1.useState(false), expanded = _b[0], setExpanded = _b[1];
    return (react_1.default.createElement("div", { className: "sf-error-dialog-content" },
        react_1.default.createElement("div", { className: "icon-container" },
            react_1.default.createElement(ErrorRounded_1.default, null)),
        react_1.default.createElement("div", { className: "title" }, title ? title : 'Error!'),
        react_1.default.createElement("div", { className: "message" }, message ? (react_1.default.createElement("div", { onClick: function () {
                setExpanded(true);
            } },
            message,
            messageJson ? react_1.default.createElement(Info_1.default, null) : null)) : ('An error has occured')),
        expanded ? (react_1.default.createElement("div", { className: "message-json" },
            react_1.default.createElement("pre", null, JSON.stringify(messageJson, null, 2)))) : null));
};
exports.default = SFErrorDialogContent;
